import { cva as e } from "class-variance-authority";
// src/design/loading/styles.ts
var t = e("animate-spin rounded-full border-solid", {
	variants: {
		size: {
			xs: "w-3 h-3 border-[1.5px]",
			sm: "w-4 h-4 border-2",
			md: "w-6 h-6 border-2",
			lg: "w-8 h-8 border-[3px]",
			xl: "w-12 h-12 border-[3px]",
			"2xl": "w-16 h-16 border-4"
		},
		variant: {
			primary: "!border-primary !border-t-transparent",
			secondary: "!border-muted-foreground !border-t-transparent",
			success: "!border-success !border-t-transparent",
			danger: "!border-destructive !border-t-transparent",
			warning: "!border-warning !border-t-transparent"
		}
	},
	defaultVariants: {
		size: "md",
		variant: "primary"
	}
}), n = e("flex items-center gap-1", {
	variants: { size: {
		xs: "gap-0.5",
		sm: "gap-1",
		md: "gap-1.5",
		lg: "gap-2",
		xl: "gap-2.5"
	} },
	defaultVariants: { size: "md" }
}), r = e("rounded-full animate-pulse", {
	variants: {
		size: {
			xs: "w-1 h-1",
			sm: "w-1.5 h-1.5",
			md: "w-2 h-2",
			lg: "w-2.5 h-2.5",
			xl: "w-3 h-3"
		},
		variant: {
			primary: "bg-primary",
			secondary: "bg-muted-foreground",
			success: "bg-success",
			danger: "bg-destructive",
			warning: "bg-warning"
		}
	},
	defaultVariants: {
		size: "md",
		variant: "primary"
	}
});
e("animate-pulse rounded", {
	variants: { variant: {
		light: "bg-muted",
		medium: "bg-muted/80",
		dark: "bg-muted/60"
	} },
	defaultVariants: { variant: "medium" }
});
var i = e("animate-pulse rounded bg-muted", {
	variants: { variant: {
		text: "h-4 rounded",
		circle: "rounded-full",
		rect: "rounded-lg",
		rounded: "rounded-md"
	} },
	defaultVariants: { variant: "rect" }
}), a = e("flex items-center justify-center", {
	variants: {
		fullScreen: {
			true: "fixed inset-0 z-modal bg-popover backdrop-blur-sm",
			false: ""
		},
		centered: {
			true: "min-h-[200px]",
			false: ""
		}
	},
	defaultVariants: {
		fullScreen: !1,
		centered: !0
	}
}), o = e("absolute inset-0 flex items-center justify-center bg-popover backdrop-blur-sm", {
	variants: { rounded: {
		true: "rounded-lg",
		false: ""
	} },
	defaultVariants: { rounded: !1 }
});
export { r as dot, n as dotsContainer, a as loadingContainer, o as overlay, i as skeleton, t as spinner };

//# sourceMappingURL=styles.js.map